import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Box, Text, Grid } from '@chakra-ui/react'

import { Input } from 'src/components/Form'
import Button from 'src/components/Button/Button'
import { Form, Field } from 'react-final-form'

import { Layout, Container, PageTitle } from 'src/components/Layout'
import ThankYou from 'src/modals/ThankYou/index'

import Disclaimer from 'src/modals/Disclaimer'
import intlMessages from '../../translations'

class AddPinkSlipAdress extends Component {
  state = {
    address: null,
    confirmed: false,
    error: false,
    showDisclaimer: false,
  }

  componentDidUpdate(prevProps) {
    const { successful, submitting } = this.props

    if (!submitting && prevProps.submitting && successful) {
      this.setState({
        showDisclaimer: false,
        confirmed: true,
      })
    }

    if (!submitting && prevProps.submitting && !successful) {
      this.setState({
        showDisclaimer: false,
        error: true,
      })
    }
  }

  handleSubmit = values => {
    this.setState({
      address: values,
      showDisclaimer: true,
    })
  }

  handleCloseDisclaimer = () => {
    this.setState({
      showDisclaimer: false,
    })
  }

  handleSubmitDisclaimer = () => {
    const { document, sendPinkSlipAddress } = this.props
    const { address } = this.state
    const data = {
      ...address,
      documentId: document.id,
      documentType: document.type,
    }

    sendPinkSlipAddress(data)
  }

  renderThankYouContent = data => {
    if (!data) return

    const { address, city, state, country, zip } = data

    return (
      <Text align={'center'}>
        <FormattedMessage
          id='app.document.pinkslips.successBody'
          defaultMessage='We are mailing your pink slip to'
        />
        <br />
        <b>
          {address}, {city}, {zip}, {state}, {country}
        </b>
      </Text>
    )
  }

  renderError = () => {
    return (
      <div style={{ textAlign: 'center' }}>
        <h2>Error!</h2>
        <p>
          <FormattedMessage
            id='app.document.pinkslips.errorBody'
            defaultMessage='Something went wrong. Please try again.'
          />
        </p>
      </div>
    )
  }

  renderForm = () => {
    const { intl } = this.props

    return (
      <Box>
        <Text mb={'16px'} fontSize={'16px'} align={'center'}>
          <FormattedMessage
            id='app.document.pinkslips.whereToShipDescription'
            defaultMessage='Which address would you like us to send the pink slip to?'
          />
        </Text>
        <Form
          onSubmit={this.handleSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Field
                name='address'
                render={({ input, meta }) => (
                  <Box mb={'20px'}>
                    <Input
                      placeholder={intl.formatMessage(intlMessages.documentPinkSlipLabelAddress)}
                      error={meta}
                      name='address'
                      {...input}
                    />
                  </Box>
                )}
              />
              <Field
                name='city'
                render={({ input, meta }) => (
                  <Box mb={'20px'}>
                    <Input
                      placeholder={intl.formatMessage(intlMessages.documentPinkSlipLabelCity)}
                      error={meta}
                      name='city'
                      {...input}
                    />
                  </Box>
                )}
              />
              <Field
                name='country'
                render={({ input, meta }) => (
                  <Box mb={'20px'}>
                    <Input
                      placeholder={intl.formatMessage(intlMessages.documentPinkSlipLabelCountry)}
                      error={meta}
                      name='country'
                      {...input}
                    />
                  </Box>
                )}
              />
              <Grid templateColumns='repeat(2, 1fr)' gap={'10px'}>
                <Field
                  name='state'
                  render={({ input, meta }) => (
                    <Box mb={'20px'}>
                      <Input
                        placeholder={intl.formatMessage(intlMessages.documentPinkSlipLabelState)}
                        error={meta}
                        name='state'
                        {...input}
                      />
                    </Box>
                  )}
                />
                <Field
                  name='zip'
                  render={({ input, meta }) => (
                    <Box mb={'20px'}>
                      <Input
                        placeholder={intl.formatMessage(intlMessages.documentPinkSlipLabelZip)}
                        error={meta}
                        name='zip'
                        {...input}
                      />
                    </Box>
                  )}
                />
              </Grid>

              <Button type='submit' size='lg'>
                <FormattedMessage id='app.document.pinkSlips.submit' defaultMessage='Submit' />
              </Button>
            </form>
          )}
        />
      </Box>
    )
  }

  render() {
    const { showDisclaimer, address, error, confirmed } = this.state
    const { intl, submitting, features } = this.props

    const foundedFeature = features.find(f => f.id == 'documents')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.documentsHeadline)

    return (
      <Layout>
        <PageTitle
          title={intl.formatMessage(intlMessages.documentPinkSlipHeadline)}
          subtitle={title}
        />
        <Container padder className='global-centered-desktop-content'>
          {!error ? this.renderForm() : this.renderError()}
          <ThankYou
            visible={confirmed}
            onClose={this.handleCloseThankYouModal}
            renderContent={this.renderThankYouContent(address)}
          />
          <Disclaimer
            visible={showDisclaimer}
            loading={submitting}
            onClose={this.handleCloseDisclaimer}
            onSubmit={this.handleSubmitDisclaimer}
          />
        </Container>
      </Layout>
    )
  }
}

export default injectIntl(AddPinkSlipAdress)
